{% block sw_cms_element_top_finder_selectboxes %}
    <div class="sw-cms-el-top-finder-selectboxes">
        <div class="sw-cms-el-top-finder-selectboxes__content">
            <div class="sw-cms-el-top-finder-selectboxes__preview">
                <span class="sw-cms-el-top-finder-selectboxes__label">TopFinder</span>
                <div class="sw-cms-el-top-finder-selectboxes__dropdowns">
                    <span class="sw-cms-el-top-finder-selectboxes__placeholder">Brand</span>
                    <span class="sw-cms-el-top-finder-selectboxes__arrow">&#x25BE;</span>
                    <span class="sw-cms-el-top-finder-selectboxes__placeholder">Series / Type</span>
                    <span class="sw-cms-el-top-finder-selectboxes__arrow">&#x25BE;</span>
                    <span class="sw-cms-el-top-finder-selectboxes__placeholder">Device</span>
                    <span class="sw-cms-el-top-finder-selectboxes__arrow">&#x25BE;</span>
                </div>
            </div>
        </div>
    </div>
{% endblock %}
